// extracted by mini-css-extract-plugin
module.exports = {"stickyFooter":"StickyFooter_stickyFooter__2Z4K5","fullWidth":"StickyFooter_fullWidth__3N97J"};